module.exports = __webpack_public_path__ + "img/2025big12.3844bc52.jpg";